// Set these in your own, local `.env` file
export let usecaseApiUrl = localStorage.getItem('UsecaseApiUrl') ?? process.env.REACT_APP_USECASE_API_URL
export let missionApiUrl = localStorage.getItem('MissionApiUrl') ?? process.env.REACT_APP_MISSION_API_URL
export const droneUpdateSpeed = process.env.REACT_APP_DRONE_UPDATE_SPEED

export let apiUrl = localStorage.getItem('ApiUrl') ?? usecaseApiUrl?.slice().replace('http://', '').replace(':5001/api', '') ?? 'localhost'

export function setApiUrl(url: string) {
    usecaseApiUrl = 'http://' + url + ':5001/api'
    missionApiUrl = 'http://' + url + ':5001/api'

    localStorage.setItem('UsecaseApiUrl', usecaseApiUrl)
    localStorage.setItem('MissionApiUrl', missionApiUrl)
    localStorage.setItem('ApiUrl', url)

    apiUrl = url
}
